// @tg-seq: 11036
/**
 * nav_tgc_11036_default_left_menu.tsx
 *
 * LEFT MENU Pattern - Left Overlay Menu with Accordion
 *
 * Visual style: Drawer-based left sidebar with floor-grouped accordion sections.
 * Same button data as elevator, different presentation (horizontal layout with sidebar).
 *
 * Created: 2026-06-21
 * Pattern ID: 5 (LEFT_MENU)
 */
import React from 'react';
import { getTsxFileName } from '../../utils/componentIdentity';
import { DirmLeftMenuPattern } from '../ComponentTemplates/DirectoryPatterns';

const Self = () => <DirmLeftMenuPattern seq={11036} />;
Self.displayName = getTsxFileName(import.meta.url);

export default Self;
